import { defineStore } from 'pinia'

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    routes: [
      {
        path: '/competition/manage',
        name: 'CompetitionManage',
        meta: { title: '赛事管理', affix: true }
      },
      {
        path: '/referee',
        name: 'Referee',
        meta: { title: '裁判' }
      },
      {
        path: '/certificate',
        name: 'Certificate',
        meta: { title: '证书' }
      },
      {
        path: '/order',
        name: 'Order',
        meta: { title: '订单' }
      },
      {
        path: '/system',
        name: 'System',
        meta: { title: '系统管理' },
        children: [
          {
            path: '/system/user',
            name: 'User',
            meta: { title: '用户管理' }
          },
          {
            path: '/system/role',
            name: 'Role',
            meta: { title: '角色权限' }
          },
          {
            path: '/system/menu',
            name: 'Menu',
            meta: { title: '菜单管理' }
          },
          {
            path: '/system/dept',
            name: 'Dept',
            meta: { title: '部门管理' }
          },
          {
            path: '/system/post',
            name: 'Post',
            meta: { title: '岗位管理' }
          },
          {
            path: '/system/dict',
            name: 'Dict',
            meta: { title: '字典管理' }
          },
          {
            path: '/system/config',
            name: 'Config',
            meta: { title: '参数设置' }
          }
        ]
      }
    ],
    addRoutes: [],
    // 新增菜单数据状态
    menus: [],
    userInfo: null
  }),
  
  getters: {
    getRoutes: (state) => state.routes,
    getAddRoutes: (state) => state.addRoutes,
    getMenus: (state) => state.menus,
    getUserInfo: (state) => state.userInfo
  },
  
  actions: {
    generateRoutes(roles) {
      return new Promise(resolve => {
        let accessedRoutes
        if (roles.includes('admin')) {
          accessedRoutes = this.asyncRoutes || []
        } else {
          accessedRoutes = this.filterAsyncRoutes(this.asyncRoutes, roles)
        }
        this.addRoutes = accessedRoutes
        this.routes = this.constantRoutes.concat(accessedRoutes)
        resolve(accessedRoutes)
      })
    },
    
    filterAsyncRoutes(routes, roles) {
      const res = []
      
      routes.forEach(route => {
        const tmp = { ...route }
        if (this.hasPermission(roles, tmp)) {
          if (tmp.children) {
            tmp.children = this.filterAsyncRoutes(tmp.children, roles)
          }
          res.push(tmp)
        }
      })
      
      return res
    },
    
    hasPermission(roles, route) {
      if (route.meta && route.meta.roles) {
        return roles.some(role => route.meta.roles.includes(role))
      } else {
        return true
      }
    },

    // 设置菜单数据
    setMenus(menus) {
      this.menus = menus
    },

    // 设置用户信息
    setUserInfo(userInfo) {
      this.userInfo = userInfo
    },

    // 设置登录信息（包含用户信息和菜单）
    setLoginInfo(loginData) {
      this.userInfo = loginData.user_info
      this.menus = loginData.menus
    }
  }
})
